/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type { DeleteUsersIdMutationResponse, DeleteUsersIdPathParams, DeleteUsersId400, DeleteUsersId403 } from '../entities/DeleteUsersId'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query'
import { deleteUsersId } from '../api/deleteUsersId'
import { useMutation } from '@tanstack/react-query'

export const deleteUsersIdMutationKey = () => [{ url: '/users/{id}' }] as const

export type DeleteUsersIdMutationKey = ReturnType<typeof deleteUsersIdMutationKey>

/**
 * @description Удаление пользователя админом компании
 * @summary Удаление пользователя
 * {@link /users/:id}
 */
export function useDeleteUsersId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      DeleteUsersIdMutationResponse,
      ResponseErrorConfig<DeleteUsersId400 | DeleteUsersId403>,
      { id: DeleteUsersIdPathParams['id'] },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof client }
  } = {},
) {
  const { mutation: { client: queryClient, ...mutationOptions } = {}, client: config = {} } = options ?? {}
  const mutationKey = mutationOptions?.mutationKey ?? deleteUsersIdMutationKey()

  return useMutation<DeleteUsersIdMutationResponse, ResponseErrorConfig<DeleteUsersId400 | DeleteUsersId403>, { id: DeleteUsersIdPathParams['id'] }, TContext>(
    {
      mutationFn: async ({ id }) => {
        return deleteUsersId(id, config)
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  )
}